import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslocoPipe } from '@jsverse/transloco';

import { ComplexModalTemplate } from '@connect-services/client/components/complexe-modal/complex-modal-template.component';
import { CreateFieldInterventionService } from '@connect-services/client/services/create-field-intervention.service';
import { ProgressBarComponent } from '@shared/client/components/progress-bar/progress-bar.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ComplexModalTemplate, ProgressBarComponent, TranslocoPipe],
    selector: 'app-valid-entities-selection-modal',
    templateUrl: './valid-entities-selection-modal.component.html',
})
export class ValidEntitiesSelectionModalComponent {
    public readonly errorMessage = signal<string | undefined>(undefined);

    protected readonly createFieldInterventionService = inject(CreateFieldInterventionService);
    protected dialogRef = inject(MatDialogRef<ValidEntitiesSelectionModalComponent>);
    protected readonly entitiesToUpdateCount = computed<number>(
        (): number =>
            this.createFieldInterventionService.selectedEntitiesNumber() -
            this.createFieldInterventionService.alreadySelectedFieldInterventionEntities.length +
            2 * this.createFieldInterventionService.unselectedEntitiesNumber(),
    );
    protected readonly message = signal<string>('waitInterventionWillBeAvailable');
    protected readonly title = signal<string>('creatingFieldIntervention');
    protected readonly updatedEntitiesCount = computed<number>((): number =>
        this.createFieldInterventionService.updatedEntities(),
    );
}
